// extracted by mini-css-extract-plugin
export default {"signin-register-container":"signUpLoginTab_signin-register-container__60AL+","register":"signUpLoginTab_register__QKRGr","signin":"signUpLoginTab_signin__BPs++"};